import { render, staticRenderFns } from "./MegaMenu.template.vue?vue&type=template&id=3d614346&scoped=true&"
var script = {}
import style0 from "./MegaMenu.template.vue?vue&type=style&index=0&id=3d614346&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d614346",
  null
  
)

export default component.exports